import C from '../actions/constants'

export const so3Correction = (state = {}, action) => {
    switch (action.type) {
        case C.SET_SO3_CORRECTION_VALUES:
            return { ...state, ...action.payload }
        default:
            return state
    }
}